import { Button, FormControl, MenuItem, Select, TextField } from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OptimizationGroupId } from './types';

interface OptimizationIdSelectProps {
  optimizationGroupId: string;
  setId: Dispatch<SetStateAction<string>>;
}

export const OptimizationIdSelect = ({ optimizationGroupId, setId }: OptimizationIdSelectProps) => {
  const [t] = useTranslation();
  const [currentId, setCurrentId] = useState(optimizationGroupId);
  return (
    <div className="flex flex-wrap gap-2">
      <FormControl>
        <Select
          id="id"
          className="px-2 bg-white h-10"
          value={currentId}
          onChange={(e) => {
            setCurrentId(e.target.value);
          }}
        >
          {Object.entries(OptimizationGroupId).map((element) => (
            <MenuItem value={element[1]} key={element[1]}>
              {element[0]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        value={currentId}
        className="w-[12ch]"
        name="custom id"
        placeholder="id"
        InputProps={{
          className: 'bg-white h-10',
        }}
        onChange={(e) => setCurrentId(e.target.value)}
      />

      <Button color="primary" onClick={() => setId(currentId)}>
        {t('SHARED_SUBMIT')}
      </Button>
    </div>
  );
};
